import { render, staticRenderFns } from "./Reslink.vue?vue&type=template&id=e1e1e420&scoped=true&"
import script from "./Reslink.vue?vue&type=script&lang=js&"
export * from "./Reslink.vue?vue&type=script&lang=js&"
import style0 from "./Reslink.vue?vue&type=style&index=0&id=e1e1e420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e1e420",
  null
  
)

export default component.exports